// extracted by mini-css-extract-plugin
export default {"loading_container":"SkeletonLoader_loading_container__PCRsF","shimmer":"SkeletonLoader_shimmer__3IyBJ"};